import React from 'react';
import "./CommonSearch.scss";
import { SearchIcon, CloseIcon } from "../../../assets/Svg/SvgImages.jsx";
import ButtonTriangleSpinner from "../../common/ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
const CommonSearch = ({
  label,
  placeholder,
  name,
  className,
  onChange,
  onClear,
  maxLength,
  loading,
  value
}) => {
  const isControlled = value !== undefined && value !== null;
  const strValue = isControlled ? String(value) : '';
  const showClear = isControlled && strValue.length > 0 && !loading;
  const handleClear = e => {
    e.preventDefault();
    if (typeof onClear === "function") {
      onClear(e);
    }
    if (onChange) {
      onChange({
        target: {
          value: ''
        }
      });
    }
  };
  return <>
            <div className={`commonSearch ${className ?? ""}`}>
                {label && <label className='searhLabel'>{label}</label>}
                <div className={['searchInput', loading ? 'searchInput--loading' : '', showClear ? 'searchInput--hasClear' : ''].filter(Boolean).join(' ')}>
                    <span className='searchIcon'><SearchIcon /></span>
                    <input type="text" className="" maxLength={maxLength} id="searchbox" name={name} placeholder={placeholder} onChange={onChange} aria-busy={loading ? true : undefined} {...isControlled ? {
          value: strValue
        } : {}} />
                    {loading ? <span className="commonSearch__spinner" aria-hidden>
                            <ButtonTriangleSpinner size={16} color="var(--accent)" />
                        </span> : null}
                    {showClear ? <button type="button" className="commonSearch__clear" onClick={handleClear} aria-label="Clear search">
                            <CloseIcon />
                        </button> : null}
                </div>
            </div>
        </>;
};
export default CommonSearch;